import { render, staticRenderFns } from "./ProjectsDetail.vue?vue&type=template&id=89a43090&"
import script from "./ProjectsDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports